import React from 'react';

function TextoInput({ texto }) {
    return (
        <span>
            {texto + ':\u00A0\u00A0'}
        </span>
    );
}

export default TextoInput;